import {
  AUTO_LOGIN,
  RESET_STATE,
  GET_DEVICES,
  ADD_NOTIFICATIONS,
  EDIT_USER,
  EDIT_DEVICE,
  UPDATE_ACCOUNT_TYPE,
  COLD_RESET,
  FACTORY_RESET,
  REGISTER_DEVICE,
  SET_DEVICE_INFO,
  UPDATE_FIRMWARE,
  GET_WEATHER,
  SEND_MESSAGE,
} from "./types";

const autoLoginAction = ({ payload }) => ({
  type: AUTO_LOGIN,
  payload,
});

const getDevicesAction = () => ({
  type: GET_DEVICES,
});

const resetStateAction = () => ({
  type: RESET_STATE,
});

const addNotificationAction = ({ payload }) => ({
  type: ADD_NOTIFICATIONS,
  payload,
});

const editUserInfoAction = ({ payload }) => ({
  type: EDIT_USER,
  payload,
});

const editDeviceInfoAction = ({ payload }) => ({
  type: EDIT_DEVICE,
  payload,
});

const updateAccountTypeAction = ({ payload }) => ({
  type: UPDATE_ACCOUNT_TYPE,
  payload,
});

const coldResetAction = ({ payload }) => ({
  type: COLD_RESET,
  payload,
});

const factoryResetAction = ({ payload }) => ({
  type: FACTORY_RESET,
  payload,
});

const registerDeviceAction = ({ payload }) => ({
  type: REGISTER_DEVICE,
  payload,
});

const setDeviceInfoAction = ({ payload }) => ({
  type: SET_DEVICE_INFO,
  payload,
});

const updateFirmwareAction = ({ payload }) => ({
  type: UPDATE_FIRMWARE,
  payload,
});

const getWeatherAction = ({ payload }) => ({
  type: GET_WEATHER,
  payload,
});

const sendMessageAction = ({ payload }) => ({
  type: SEND_MESSAGE,
  payload,
});

export {
  autoLoginAction,
  resetStateAction,
  getDevicesAction,
  addNotificationAction,
  editUserInfoAction,
  editDeviceInfoAction,
  updateAccountTypeAction,
  coldResetAction,
  factoryResetAction,
  registerDeviceAction,
  setDeviceInfoAction,
  updateFirmwareAction,
  getWeatherAction,
  sendMessageAction,
};
